import React from 'react';
import { Field, change } from 'redux-form';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import NumberInput from './NumberInput';

const NumberFieldWrapper = (WrappedComponent) => (props) => {
  const { name, timer, isDisabled } = props;

  return (
    <Field
      name={name}
      component={WrappedComponent}
      props={{
        timer,
        isDisabled,
      }}
    />
  );
};

/**
 * Redux-form wrapper for NumberInput component.
 * */
const NumberField = (props) => {
  const {
    input,
    meta: { form, dispatch },
    timer,
    isDisabled,
  } = props;

  const updateTimer = (newValue) =>
    newValue > 0
      ? dispatch(change(form, input.name, parseInt(newValue, 10)))
      : dispatch(change(form, input.name, null));

  return (
    <NumberInput
      icon={<Icon id="timer" />}
      description={timer > 1 ? 'mins' : 'min'}
      value={timer || undefined}
      onChange={updateTimer}
      isDisabled={isDisabled}
    />
  );
};

NumberField.displayName = 'NumberField';

export default NumberFieldWrapper(NumberField);
